import { Box, Button, Container, Grid, Tab } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useAppContext } from "../../../../libs/app-core/AppContext";
import { Toast } from "../../../../libs/app-core/Toast";
import {
  linear_content_style,
  linear_item,
  linear_v,
} from "../../../../libs/linear-layout/LinearLayout";
import Label from "../../../../libs/rhf-mui/ui/Label";
import AppBarTabs from "../../../components/AppBarTabs";
import TabPage from "../../../components/TabPage";
import UcDgvCustomPagination from "../../../components/UcDgvCustomPagination";
import UcDgvCustomToolbar from "../../../components/UcDgvCustomToolbar";
import { DGV_LOCAL_TEXT } from "../../../components/UIHelper";
import { UniFunc } from "../../../dao/UniFunc";
import { SpwkToHisInfo } from ".././SpwkToHisInfo";
import { MemberDAO } from "../../../dao/MemberDAO";
import { Member } from "../../../dao/Member";
import { HisUiDto } from "../../../export_spwk/HisDtoManager/HisDto";
import UcUiManager, { HisExcelDto } from "./UcUiManager";

type Props = {
  /** 左側選單 Focus 的轉檔結果 */
  CurrInfo: SpwkToHisInfo | undefined;

  /* 篩選: 特作編號 (此轉檔結果，繼續篩選，只看到指定特作) */
  CurrUniFunc: UniFunc | null;
  infoList: SpwkToHisInfo[];
};

const UcHisTestView = ({
  CurrInfo,
  CurrUniFunc,
  infoList,
  ...props
}: Props) => {
  const [memberList, setMemberList] = useState<Member[]>([]);
  const [excelList, setExcelList] = useState<HisExcelDto[]>([]);
  const [UiList, setUiList] = useState<HisUiDto[]>([]);

  const ctx = useAppContext();

  const [CurrTabIndex, set_CurrTabIndex] = useState("tab_Table");
  async function getMember(infoList: SpwkToHisInfo[]) {
    const tempMemberList: Member[] = [];
    for (const info of infoList) {
      let member = await MemberDAO.WS_FetchByGuid(info.Ans.member_guid);
      // 檢查成員是否已經存在於 tempMemberList 中
      if (
        !tempMemberList.some(
          (existingMember) => existingMember.guid === member.guid
        )
      ) {
        tempMemberList.push(member);
      }
    }
    setMemberList(tempMemberList);
  }

  useEffect(() => {
    getMember(infoList);
  }, [infoList]);

  useEffect(() => {
    let updatedExcelList: HisExcelDto[] = [];
    let find_info: SpwkToHisInfo | undefined = undefined;
    for (const member of memberList) {
      find_info = infoList.find((x) => x.Ans.member_guid === member.guid);
      if (find_info !== undefined) {
        const ucUiManager = UcUiManager();
        ucUiManager.fillValue(member, updatedExcelList, find_info);
      }
    }
    setExcelList(updatedExcelList);

    if (updatedExcelList.length > 0) {
      const ucUiManager = UcUiManager();
      if (find_info !== undefined) {
        let Ui = ucUiManager.getUiInfo(updatedExcelList, memberList, find_info);
        setUiList(Ui);
      }
    }
  }, [memberList, infoList]);

  const json = JSON.stringify(excelList, null, 4);
  let test = JSON.stringify(UiList, null, 4);

  return (
    <Grid {...linear_v}>
      {/* 上方控制區 */}
      <Grid {...linear_item}>
        <Container>{render_Tabs()}</Container>
      </Grid>

      {/* 下方內容區 */}
      <Grid {...linear_item} flex={1} sx={{}}>
        {render_TabControl()}
      </Grid>
    </Grid>
  );

  function render_Tabs() {
    return (
      <Container>
        <AppBarTabs
          AppBarTabIndex={CurrTabIndex}
          set_AppBarTabIndex={set_CurrTabIndex}
          is_light_bg={true}
        >
          <Tab label="Table" value={"tab_Table"} />
          <Tab label="JSON" value={"tab_JSON"} />
          <Tab label="UI" value={"tab_UI"} />
        </AppBarTabs>
      </Container>
    );
  }
  function render_TabControl() {
    return (
      <Box style={linear_content_style} sx={{ height: "100%", bgcolor: "" }}>
        <TabPage
          tab_key={"tab_Table"}
          curr_tab={CurrTabIndex}
          sx={{ bgcolor: "", height: "100%", overflow: "hidden" }}
        >
          <Box sx={{ height: "100%", bgcolor: "" }}>{render_DataGrid()}</Box>
        </TabPage>

        <TabPage tab_key={"tab_JSON"} curr_tab={CurrTabIndex}>
          <Container>
            <Button
              variant="contained"
              sx={{ m: 2 }}
              onClick={() => {
                navigator.clipboard.writeText(json);
                Toast.Show(ctx, "已複製到剪貼簿");
              }}
            >
              複製JSON
            </Button>
            <br />
            <Label>{json}</Label>
          </Container>
        </TabPage>

        <TabPage tab_key={"tab_UI"} curr_tab={CurrTabIndex}>
          <Container>
            <Button
              variant="contained"
              sx={{ m: 2 }}
              onClick={() => {
                navigator.clipboard.writeText(test);
                Toast.Show(ctx, "已複製到剪貼簿");
              }}
            >
              複製JSON
            </Button>
            <br />
            <Label>{test}</Label>
          </Container>
        </TabPage>
      </Box>
    );
  }
  function render_DataGrid(): React.ReactNode {
    const columns: GridColDef<HisExcelDto>[] = [
      {
        field: "作業編號",
        headerName: "作業編號",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "部門",
        headerName: "部門",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "工號",
        headerName: "工號",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "姓名",
        headerName: "姓名",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "身分證",
        headerName: "身分證",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "既往病史",
        headerName: "既往病史",
        width: 600,
        description: "",
        editable: true,
      },
      {
        field: "是否吸菸",
        headerName: "是否吸菸",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "是否嚼食檳榔",
        headerName: "是否嚼食檳榔",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "是否喝酒",
        headerName: "是否喝酒",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "每日平均睡眠時間",
        headerName: "每日平均睡眠時間",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "自覺症狀",
        headerName: "自覺症狀",
        width: 600,
        description: "",
        editable: true,
      },
      {
        field: "糖尿病",
        headerName: "糖尿病",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "吸菸",
        headerName: "吸菸",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "曾經從事",
        headerName: "曾經從事",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "曾經從事開始日",
        headerName: "曾經從事開始日",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "曾經從事結束日",
        headerName: "曾經從事結束日",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "目前從事",
        headerName: "目前從事",
        width: 120,
        description: "",
        editable: true,
      },
      {
        field: "目前從事開始日",
        headerName: "目前從事開始日",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "目前從事結束日",
        headerName: "目前從事結束日",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "Shift",
        headerName: "是否輪班",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "AverageWorkHoursInPastMonth",
        headerName: "一個月內平均週工時",
        width: 200,
        description: "",
        editable: true,
      },
      {
        field: "AverageWorkHoursInPastSixMonth",
        headerName: "六個月內平均週工時",
        width: 200,
        description: "",
        editable: true,
      },
    ];

    return (
      <div style={linear_content_style}>
        <DataGrid
          style={{ width: "100%", backgroundColor: "white", padding: "12px" }}
          getRowId={(data) =>
            data.身分證 && data.姓名 && data.作業編號
              ? `${data.身分證}-${data.姓名}-${data.作業編號}`
              : ""
          }
          rows={excelList}
          columns={columns}
          localeText={DGV_LOCAL_TEXT} // 中文
          components={{
            Toolbar: () => {
              return <UcDgvCustomToolbar></UcDgvCustomToolbar>;
            },
            Pagination: () => {
              return <UcDgvCustomPagination />;
            },
          }}
          density={"compact"}
          pageSize={100}
          rowsPerPageOptions={[100]}
          hideFooterSelectedRowCount
          // hideFooter

          onCellEditCommit={async ({ id, field, value }) => {}}
        />
      </div>
    );
  }
};

export default UcHisTestView;
